import { apiDelete, get, post } from ".";

export const getCustomer = async () => {
  const response = await get("/offRamp/getCustomer");
  return response;
};

export const createCustomer = async (data: {
  full_name: string;
  type: string;
}) => {
  const response = await post("/offRamp/createCustomer", {
    payload: data,
  });
  return response;
};

export const deleteCustomer = async () => {
  const response = await post("/offRamp/deleteCustomer");
  return response;
};

export const sendVerificationCode = async (data: { email: string }) => {
  const response = await post("/offRamp/send-verification", data);
  return response;
};

export const verifyVerificationCode = async (data: {
  email: string;
  code: string;
}) => {
  const response = await post("/offRamp/verify-email", data);
  return response;
};

export interface ExternalAccount {
  id: string;
  account_name: string | null;
  account_owner_name: string;
  account_owner_type: string | null;
  account_type: string;
  active: boolean;
  bank_name: string;
  beneficiary_address_valid: boolean;
  business_name: string | null;
  created_at: string;
  currency: string;
  customer_id: string;
  first_name: string | null;
  last_name: string | null;
  last_4: string;
  routing_number: string;
  checking_or_savings: string;
  updated_at: string;
}

export const createExternalAccount = async (data: {
  currency: string;
  account_type: string;
  bank_name: string;
  account_owner_name: string;
  account: {
    account_number: string;
    routing_number: string;
  };
  address: {
    street_line_1: string;
    city: string;
    state: string;
    country: string;
    postal_code: string;
  };
}) => {
  const response = await post("/offRamp/createExternalAccount", {
    payload: data,
  });
  return response;
};

export const getExternalAccount = async () => {
  const response: any = await get("/offRamp/getExternalAccounts");
  return response.data as ExternalAccount[];
};

export interface LiquidationAddress {
  address: string;
  chain: string;
  created_at: string;
  currency: string;
  destination_currency: string;
  destination_payment_rail: string;
  destination_wire_message: string;
  external_account_id: string;
  id: string;
  state: string;
  updated_at: string;
}

export const getLiquidationAddress = async () => {
  const response: any = await get("/offRamp/getLiquidationAddresses");
  return response.data as LiquidationAddress[];
};

export const createLiquidationAddress = async (data: {
  external_account_id: string;
  chain: string;
  currency: string;
  destination_payment_rail: string;
  destination_currency: string;
}) => {
  const response: any = await post("/offRamp/createLiquidationAddress", {
    payload: data,
  });
  console.log(response, "response");
  return response;
};
